import { Component, type ErrorInfo, type ReactNode } from 'react'

// ErrorBoundary: a single component throw must never blank the whole operator
// UI. It catches a render error, shows the message + a reload, and logs the
// stack — a transient bad snapshot (mid-rethink, omitted slice) degrades to a
// recoverable card instead of a black screen.
export class ErrorBoundary extends Component<
  { children: ReactNode },
  { error: Error | null }
> {
  state = { error: null as Error | null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('UI error boundary caught:', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <div className="errboundary">
          <h2>Something broke in the view</h2>
          <p className="errboundary-msg">{this.state.error.message}</p>
          <div className="errboundary-actions">
            <button onClick={() => this.setState({ error: null })}>Try again</button>
            <button onClick={() => window.location.reload()}>Reload</button>
          </div>
          <pre className="errboundary-stack">{this.state.error.stack}</pre>
        </div>
      )
    }
    return this.props.children
  }
}
